import styles from "../product/Product.module.css";
import cancel_icon from '~/public/images/cancel-icon.inline.svg';
import InfoOutlined from "@material-ui/icons/InfoOutlined";
import classes from './index.module.scss'
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { getCountryWiseAttribute } from "/lib/services/helpers/getCountryData";
import { getConfigDataSync } from "/lib/services/helpers/cache/getConfigData";

const countryDropDown = [{ countryCode: 'GB', countryName: 'UK' }, { countryCode: 'global', countryName: 'Rest of World' }]

const NotifyModal = ({ handleModalClose, className, redirectUrl = null, hreflangUrl = null, isOpen }) => {
    const [counryBtn, setCountryBtn] = useState(true);
    const [countryValue, setCountryValue] = useState(null);
    const [selectAttribute, setSelectAttribute] = useState(null);
    const router = useRouter();
    const storeData = typeof window != "undefined" ? window["__store_data__"] : getConfigDataSync()

    const attributeMap = {
        'hreflang_url': hreflangUrl,
        'redirect_url': redirectUrl
    };

    const countryStoreAttributeMap = {
        GB: storeData?.storeConfig?.uk_redirect_home || 'https://www.kamaayurveda.com/uk/en_GB/',
        global: storeData?.storeConfig?.global_redirect_home || 'https://www.kamaayurveda.com/ww/en'
    };

    const handleChange = (e) => {
        const value = e.target.value; // GB or global

        if (value) {
            const attribute = getCountryWiseAttribute(value); // Based on the dropdown, get hreflang or redirect attribute name
            setSelectAttribute(attribute);
            setCountryValue(value);
            setCountryBtn(false);
        } else {
            setCountryBtn(true); // change store btn should be disabled
        }
    }

    const handleRedirection = () => {
        const redirection = attributeMap[selectAttribute] || countryStoreAttributeMap[countryValue];
        router.push(redirection);
    }

    // To disable scroll and add overlay to this class so user can't see the content of website
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('no-scroll');
        } else {
            document.body.classList.remove('no-scroll');
        }

        return () => {
            document.body.classList.remove('no-scroll');
        };
    }, [])

    return (
        <>
            <div className={classes['modal-overlay']}></div>
            <div className={styles.modal_freetrial}>
                <div className={styles.modal_freetrial_main_colm}>
                    <div className={`${styles.modal_freetrial_main} ${classes['mainNotify']}`}>
                        <button type="button" className={styles.close_btn} onClick={handleModalClose}>
                            <img loading='lazy' src={cancel_icon} width={14} height={14} className="d-block" alt="cancel icon" />
                        </button >
                        <div className={`${styles.modal_body} ${classes[className]}`}>
                            <InfoOutlined htmlColor='#c4601d' fontSize='large' />
                            <p className={classes.notifyMessage}>We noticed that you are from outside India.</p>
                            <div className={classes.selectCountry}>
                                <span>Select Region</span>
                                <select
                                    id="country"
                                    onChange={handleChange}
                                    name="country"
                                >
                                    <option value="">Country</option>
                                    {countryDropDown
                                        .map((element, index: number) => (
                                            <option value={element.countryCode} key={index}>
                                                {element.countryName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className={classes.btnGroup}>
                                <button disabled={counryBtn} className={classes.notifyBtn} onClick={handleRedirection}>Change Store</button>
                                {/* <button className={classes.notifyStayBtn} onClick={handleModalClose}>Stay Here</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotifyModal